import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-ink text-mist" data-id="element-69" data-mp="3gezdb400vr15">
      <div className="h-px w-full bg-celeste shadow-[0_0_10px_rgba(94,200,242,0.6)]" aria-hidden="true" data-id="element-70" data-mp="3gg1025qei1yp" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-71" data-mp="32pfgsfx1bq0a">
        <p className="text-xs" data-id="element-72" data-mp="36oo87e4lrbso">© 2026 {productShortName}. Tutti i diritti riservati.</p>
      </div>
    </footer>;
}